import Boto3Cat from './../../3cat/ui/Boto';
import Boto3CatInfo from './../../3catinfo/Boto';
import { useRouter } from 'next/router';

export default function Component(props) {
    const router = useRouter();

    const is3cat = router.asPath.indexOf('/3cat/') === 0;
    return is3cat ? <Boto3Cat {...props} /> : <Boto3CatInfo {...props} />;
}
